import { render, staticRenderFns } from "./table-widget.vue?vue&type=template&id=7c9e95c5&scoped=true"
import script from "./table-widget.vue?vue&type=script&lang=js"
export * from "./table-widget.vue?vue&type=script&lang=js"
import style0 from "./table-widget.vue?vue&type=style&index=0&id=7c9e95c5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9e95c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c9e95c5')) {
      api.createRecord('7c9e95c5', component.options)
    } else {
      api.reload('7c9e95c5', component.options)
    }
    module.hot.accept("./table-widget.vue?vue&type=template&id=7c9e95c5&scoped=true", function () {
      api.rerender('7c9e95c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/container-widget/table-widget.vue"
export default component.exports